import {AnyObject} from '../types';
import {guard} from './guard';
import {debug} from './logger';

const DEFAULT_VALUE = {};

const parse = guard((input: string) => JSON.parse(input), DEFAULT_VALUE);

export function parseJson<T = AnyObject>(input: string | undefined | null): T | undefined {
  if (!input) {
    debug.warn('empty json input:', input);
    return undefined;
  }

  const object = parse(input);
  if (object === DEFAULT_VALUE) {
    debug.warn('invalid json input:', input);
    return undefined;
  }

  return object;
}

export function parseEncodedJson<T>(input: string | undefined | null): T | undefined {
  if (!input) {
    return undefined;
  }

  try {
    return parseJson<T>(window.atob(input));
  } catch (error) {
    return undefined;
  }
}

export function encodeJson(object: AnyObject): string {
  try {
    return window.btoa(JSON.stringify(object));
  } catch (error) {
    return '';
  }
}
